console.log('bosch_app...')
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("bootstrap");
require("bootstrap-select");

// <%= javascript_pack_tag 'boschautoparts/jquery' %>
// <%= javascript_pack_tag 'boschautoparts/popper' %>
// <%= javascript_pack_tag 'boschautoparts/bootstrap' %>
// <%= javascript_pack_tag 'boschautoparts/owl' %>
// <%= javascript_pack_tag 'boschautoparts/wow' %>
// <%= javascript_pack_tag 'boschautoparts/scrollbar' %>
// <%= javascript_pack_tag 'boschautoparts/validation' %>
// <%= javascript_pack_tag 'boschautoparts/jquery_fancybox' %>
// <%= javascript_pack_tag 'boschautoparts/appear' %>
// <%= javascript_pack_tag 'boschautoparts/jquery_nice_select' %>
// <%= javascript_pack_tag 'boschautoparts/progresscircle' %>
// <%= javascript_pack_tag 'boschautoparts/jquery_ui' %>


require("./clog");
require("./landing");
// require("bootstrap-select");
// require("@fortawesome/fontawesome-free/js/all");


import 'select2'
// import 'select2/dist/css/select2.css'
import moment from 'moment';
import './daterangepicker.min'


global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

// window.addEventListener('turbolinks:load', () => {
//     $('.select2').select2({
//         // tags: true,
//         tokenSeparators: [',', ' '],
//         // allowClear: true,
//         theme: "classic",
//         width: 'resolve'
//     });
// });